const data = {
    '11-9013.00': 1,
    '13-1021.00': 1,
    '13-1074.00': 1,
    '45-2021.00': 1,
    '19-1011.00': 1,
    '45-2093.00': 1,
    '39-2021.00': 1,
    '17-3025.00': 1,
    '17-2081.00': 1,
    '19-4042.00': 1,
    '47-4041.00': 1,
    '37-2021.00': 1,
    '53-7081.00': 1,
    '51-8031.00': 1,
    '17-2051.02': 1,
    '19-4012.00': 1,
    '45-1011.00': 1,
    '19-4013.00': 1,
    '19-1012.00': 1,
    '45-2041.00': 1,
    '11-9121.01': 1,
    '45-4021.00': 1,
    '45-3031.00': 1,
    '19-4071.00': 1,
    '45-4011.00': 1,
    '19-1032.00': 1,
    '19-4043.00': 1,
    '45-4023.00': 1,
    '45-4022.00': 1,
    '45-4029.00': 1,
    '11-9121.00': 1,
    '11-9121.02': 1,
    '19-1023.00': 1,
    '45-2099.00': 1,
    '19-4021.00': 1,
    '45-2092.00': 1,
    '37-3012.00': 1,
    '19-1013.00': 1,
    '37-3013.00': 1,
    '17-2021.00': 1,
    '45-2091.00': 1,
    '49-3041.00': 1,
    '47-2021.00': 2,
    '47-2031.00': 2,
    '47-2041.00': 2,
    '47-2051.00': 2,
    '47-2061.00': 2,
    '11-9021.00': 2,
    '47-5041.00': 2,
    '53-7011.00': 2,
    '53-7021.00': 2,
    '47-5011.00': 2,
    '53-7031.00': 2,
    '47-2081.00': 2,
    '47-5023.00': 2,
    '47-2111.00': 2,
    '47-5022.00': 2,
    '47-5032.00': 2,
    '47-5099.00': 2,
    '47-4031.00': 2,
    '47-1011.00': 2,
    '47-2042.00': 2,
    '47-2043.00': 2,
    '47-2121.00': 2,
    '47-3019.00': 2,
    '47-3011.00': 2,
    '47-3012.00': 2,
    '47-3013.00': 2,
    '47-5081.00': 2,
    '47-3014.00': 2,
    '47-3015.00': 2,
    '47-3016.00': 2,
    '53-7041.00': 2,
    '47-2131.00': 2,
    '47-2132.00': 2,
    '47-5044.00': 16,
    '49-9095.00': 2,
    '47-5049.00': 2,
    '47-2073.00': 2,
    '47-2141.00': 2,
    '47-2142.00': 2,
    '47-2071.00': 2,
    '47-2072.00': 2,
    '47-2152.00': 2,
    '47-2151.00': 2,
    '47-2161.00': 2,
    '47-2171.00': 2,
    '49-9096.00': 2,
    '47-5051.00': 2,
    '47-5043.00': 2,
    '47-2181.00': 2,
    '47-5012.00': 2,
    '47-5071.00': 2,
    '47-4091.00': 2,
    '47-5013.00': 2,
    '47-2211.00': 2,
    '47-1011.03': 2,
    '47-2231.00': 2,
    '47-2022.00': 2,
    '47-2221.00': 2,
    '51-2041.00': 2,
    '47-2082.00': 2,
    '47-2053.00': 2,
    '47-2044.00': 2,
    '17-1011.00': 2,
    '17-3011.00': 2,
    '17-3022.00': 2,
    '17-2051.00': 2,
    '13-1051.00': 2,
    '17-1022.01': 2,
    '27-1025.00': 2,
    '17-1012.00': 2,
    '17-3031.00': 2,
    '17-1022.00': 2,
    '17-2051.01': 2,
    '47-2011.00': 2,
    '49-9092.00': 2,
    '47-4099.00': 2,
    '49-9012.00': 2,
    '49-9051.00': 2,
    '47-4021.00': 2,
    '37-1012.00': 2,
    '37-3019.00': 2,
    '49-9021.00': 2,
    '49-9098.00': 2,
    '47-4051.00': 2,
    '37-3011.00': 2,
    '49-9011.00': 2,
    '49-9044.00': 2,
    '49-9045.00': 2,
    '47-4071.00': 2,
    '47-2152.04': 2,
    '51-8021.00': 2,
    '47-4099.03': 2,
    '27-4011.00': 3,
    '27-3023.00': 3,
    '27-4012.00': 3,
    '27-4031.00': 3,
    '27-3043.00': 3,
    '27-3041.00': 3,
    '27-4032.00': 3,
    '27-4015.00': 3,
    '27-3099.00': 3,
    '27-4021.00': 3,
    '27-3043.05': 3,
    '27-3011.00': 3,
    '43-2099.00': 4,
    '27-4014.00': 3,
    '27-3042.00': 3,
    '27-2011.00': 3,
    '13-1011.00': 3,
    '27-2032.00': 3,
    '39-3092.00': 3,
    '27-2031.00': 3,
    '27-2012.00': 3,
    '27-2091.00': 3,
    '39-5091.00': 3,
    '27-2041.00': 3,
    '27-2042.00': 3,
    '27-2012.03': 3,
    '27-2012.04': 3,
    '27-2012.05': 3,
    '43-9031.00': 3,
    '51-5111.00': 3,
    '51-5113.00': 3,
    '51-5112.00': 3,
    '43-9081.00': 3,
    '49-2022.00': 3,
    '49-9052.00': 3,
    '27-1011.00': 3,
    '27-1019.00': 3,
    '27-1021.00': 3,
    '27-1012.00': 3,
    '27-1029.00': 3,
    '27-1022.00': 3,
    '27-1013.00': 3,
    '27-1023.00': 3,
    '27-1024.00': 3,
    '27-1014.00': 3,
    '27-1027.00': 3,
    '43-3031.00': 4,
    '15-1299.00': 4,
    '43-4021.00': 4,
    '43-4051.00': 4,
    '43-9021.00': 4,
    '43-6011.00': 4,
    '43-4071.00': 4,
    '43-1011.00': 4,
    '43-4161.00': 4,
    '43-4199.00': 4,
    '43-4111.00': 4,
    '43-4121.00': 4,
    '43-9051.00': 4,
    '53-7065.00': 4,
    '43-5041.00': 4,
    '43-4141.00': 4,
    '43-9199.00': 4,
    '43-9061.00': 4,
    '43-9071.00': 4,
    '43-4151.00': 4,
    '29-2099.08': 4,
    '43-3051.00': 4,
    '43-5051.00': 4,
    '43-5052.00': 4,
    '43-5053.00': 4,
    '43-3061.00': 4,
    '43-4171.00': 4,
    '43-6014.00': 4,
    '43-5071.00': 4,
    '43-2011.00': 4,
    '43-2021.00': 4,
    '43-9022.00': 4,
    '11-3021.00': 4,
    '11-9199.11': 4,
    '11-1011.00': 4,
    '11-1011.03': 4,
    '11-9199.02': 4,
    '11-1021.00': 4,
    '11-3031.03': 4,
    '11-9199.08': 4,
    '11-9072.00': 4,
    '11-9199.01': 4,
    '11-3013.01': 4,
    '11-3071.04': 4,
    '11-9199.09': 4,
    '11-9199.10': 4,
    '11-3111.00': 4,
    '13-1141.00': 4,
    '11-3121.00': 4,
    '13-1071.00': 4,
    '13-1075.00': 4,
    '11-3131.00': 4,
    '13-1151.00': 4,
    '11-3012.00': 4,
    '11-3051.03': 4,
    '11-3051.04': 4,
    '13-1199.04': 4,
    '13-1082.00': 11,
    '13-1041.08': 4,
    '47-4011.01': 4,
    '13-1131.00': 4,
    '11-3051.02': 4,
    '11-3051.06': 4,
    '11-3051.00': 4,
    '13-1111.00': 4,
    '13-1121.00': 4,
    '13-1199.06': 4,
    '15-2031.00': 4,
    '11-3061.00': 4,
    '11-3051.01': 4,
    '13-1199.00': 4,
    '13-1199.05': 4,
    '11-9039.00': 5,
    '11-9032.00': 5,
    '11-9033.00': 5,
    '11-9031.00': 5,
    '11-9179.01': 5,
    '25-4011.00': 5,
    '25-4022.00': 5,
    '25-4012.00': 5,
    '21-1012.00': 5,
    '25-9031.00': 5,
    '27-3091.00': 5,
    '25-4031.00': 5,
    '25-4013.00': 5,
    '25-2059.01': 5,
    '25-3011.00': 5,
    '25-1041.00': 5,
    '25-1061.00': 5,
    '25-1031.00': 5,
    '25-1062.00': 5,
    '25-1121.00': 5,
    '25-1051.00': 5,
    '25-1042.00': 5,
    '25-1011.00': 5,
    '25-2023.00': 5,
    '25-2032.00': 5,
    '25-1052.00': 5,
    '27-2022.00': 5,
    '25-1122.00': 5,
    '25-1021.00': 5,
    '25-1111.00': 5,
    '25-1063.00': 5,
    '25-1081.00': 5,
    '25-9099.00': 5,
    '25-2021.00': 5,
    '25-1032.00': 5,
    '25-1123.00': 5,
    '25-1053.00': 5,
    '25-9021.00': 5,
    '25-1124.00': 5,
    '25-1043.00': 5,
    '25-1064.00': 5,
    '25-9044.00': 5,
    '25-1071.00': 5,
    '25-1125.00': 5,
    '25-1192.00': 5,
    '25-2012.00': 5,
    '25-1112.00': 5,
    '25-1082.00': 5,
    '25-1022.00': 5,
    '25-2022.00': 5,
    '25-1072.00': 5,
    '25-1126.00': 5,
    '25-1054.00': 5,
    '25-1065.00': 5,
    '25-1199.00': 5,
    '25-2011.00': 5,
    '25-1066.00': 5,
    '25-1193.00': 5,
    '25-2031.00': 5,
    '25-3021.00': 5,
    '25-1069.00': 5,
    '25-1113.00': 5,
    '25-1067.00': 5,
    '25-2059.00': 5,
    '25-2055.00': 5,
    '25-2057.00': 5,
    '25-2051.00': 5,
    '25-2058.00': 5,
    '25-9042.00': 5,
    '25-3031.00': 5,
    '25-3041.00': 5,
    '25-1194.00': 5,
    '25-2056.00': 5,
    '13-2011.00': 6,
    '43-3011.00': 6,
    '13-2041.00': 6,
    '43-4041.00': 6,
    '43-3099.00': 6,
    '43-4131.00': 6,
    '13-2072.00': 10,
    '43-3071.00': 6,
    '13-2031.00': 6,
    '13-2051.00': 6,
    '11-3031.00': 6,
    '13-2082.00': 6,
    '11-3031.01': 6,
    '15-2011.00': 6,
    '13-1031.00': 6,
    '13-1032.00': 6,
    '43-9041.00': 6,
    '41-3021.00': 6,
    '13-2053.00': 6,
    '43-4011.00': 6,
    '13-2099.01': 6,
    '13-2054.00': 6,
    '13-2099.04': 6,
    '13-2052.00': 6,
    '41-3031.00': 14,
    '53-6051.01': 7,
    '13-1041.00': 7,
    '13-1041.06': 7,
    '13-1041.01': 7,
    '13-1041.03': 7,
    '13-2061.00': 7,
    '53-6051.00': 7,
    '13-1041.04': 7,
    '11-1031.00': 7,
    '13-1041.07': 7,
    '53-6051.07': 7,
    '55-3011.00': 7,
    '55-1011.00': 7,
    '55-1012.00': 7,
    '55-3012.00': 7,
    '55-3013.00': 7,
    '55-1013.00': 7,
    '55-3014.00': 7,
    '55-1014.00': 7,
    '55-1015.00': 7,
    '55-3015.00': 7,
    '55-2011.00': 7,
    '55-2013.00': 7,
    '55-2012.00': 7,
    '55-3016.00': 7,
    '55-1016.00': 7,
    '55-3019.00': 7,
    '55-1019.00': 7,
    '17-3029.00': 13,
    '55-3018.00': 7,
    '55-1017.00': 7,
    '33-9093.00': 7,
    '15-2099.01': 7,
    '43-9111.00': 7,
    '19-3051.00': 15,
    '43-4031.00': 7,
    '43-4061.00': 7,
    '11-9161.00': 7,
    '11-9131.00': 7,
    '45-2011.00': 7,
    '47-4011.00': 7,
    '19-5011.00': 7,
    '19-5012.00': 7,
    '13-2022.00': 7,
    '13-2023.00': 7,
    '13-2081.00': 7,
    '17-2031.00': 15,
    '19-1042.00': 8,
    '29-2031.00': 8,
    '29-2011.01': 8,
    '29-2011.02': 8,
    '29-2032.00': 8,
    '19-1041.00': 8,
    '29-2036.00': 8,
    '29-2011.04': 8,
    '29-2035.00': 8,
    '29-2012.00': 8,
    '29-2011.00': 8,
    '29-2099.01': 8,
    '29-2033.00': 8,
    '29-2099.05': 8,
    '29-2034.00': 8,
    '29-9093.00': 8,
    '29-2056.00': 8,
    '29-2072.00': 8,
    '43-6013.00': 8,
    '31-9094.00': 8,
    '31-9099.02': 8,
    '31-9099.00': 8,
    '11-9111.00': 8,
    '31-9093.00': 8,
    '31-1132.00': 8,
    '31-9095.00': 8,
    '31-9097.00': 8,
    '31-9099.01': 8,
    '31-9096.00': 8,
    '29-1291.00': 8,
    '29-1141.01': 8,
    '29-1141.02': 8,
    '29-1229.01': 8,
    '29-1071.01': 8,
    '29-1211.00': 8,
    '29-1129.01': 8,
    '29-9091.00': 8,
    '29-1181.00': 8,
    '29-1011.00': 8,
    '29-1141.04': 8,
    '29-1141.03': 8,
    '31-9091.00': 8,
    '29-1292.00': 8,
    '29-1029.00': 8,
    '29-1021.00': 8,
    '29-1213.00': 8,
    '29-2051.00': 8,
    '29-1031.00': 8,
    '29-1128.00': 8,
    '29-1215.00': 8,
    '29-9092.00': 8,
    '29-1299.00': 8,
    '29-9021.00': 8,
    '29-2092.00': 8,
    '31-1121.00': 8,
    '29-1229.02': 8,
    '29-1216.00': 8,
    '29-2061.00': 8,
    '29-1122.01': 8,
    '31-9092.00': 8,
    '29-9099.01': 8,
    '29-1129.02': 8,
    '29-1299.01': 8,
    '29-1217.00': 8,
    '29-1224.00': 8,
    '29-1151.00': 8,
    '29-1161.00': 8,
    '29-1171.00': 8,
    '31-1131.00': 8,
    '29-1218.00': 8,
    '29-1122.00': 8,
    '31-2012.00': 8,
    '31-2011.00': 8,
    '29-2057.00': 8,
    '29-1241.00': 8,
    '29-2081.00': 8,
    '29-1041.00': 8,
    '29-1022.00': 8,
    '29-1023.00': 8,
    '29-1299.02': 8,
    '29-2091.00': 8,
    '29-1222.00': 8,
    '29-1221.00': 8,
    '29-1051.00': 8,
    '29-2052.00': 8,
    '29-1229.04': 8,
    '31-2022.00': 8,
    '31-2021.00': 8,
    '29-1123.00': 8,
    '29-1071.00': 8,
    '29-1212.00': 8,
    '29-1081.00': 8,
    '29-1229.05': 8,
    '29-1024.00': 8,
    '31-1133.00': 8,
    '29-2053.00': 8,
    '29-1223.00': 8,
    '29-1124.00': 8,
    '29-1125.00': 8,
    '29-1141.00': 8,
    '29-1126.00': 8,
    '29-2099.00': 8,
    '29-1127.00': 8,
    '29-1229.06': 8,
    '29-1242.00': 8,
    '29-2055.00': 8,
    '29-1129.00': 8,
    '29-1229.03': 8,
    '29-1131.00': 8,
    '29-2012.01': 8,
    '39-6011.00': 9,
    '37-2019.00': 9,
    '39-6012.00': 9,
    '37-1011.00': 9,
    '43-4081.00': 9,
    '37-2011.00': 9,
    '11-9081.00': 9,
    '37-2012.00': 9,
    '39-3091.00': 9,
    '39-2011.00': 9,
    '27-2021.00': 9,
    '39-3099.00': 9,
    '39-3012.00': 9,
    '43-3041.00': 9,
    '41-2012.00': 9,
    '39-3011.00': 9,
    '11-9071.00': 9,
    '39-3019.00': 9,
    '39-1013.00': 9,
    '39-3021.00': 9,
    '39-9032.00': 9,
    '27-2023.00': 9,
    '39-3031.00': 9,
    '51-3011.00': 9,
    '35-3023.01': 9,
    '35-3011.00': 9,
    '35-1011.00': 9,
    '35-3023.00': 9,
    '35-2019.00': 9,
    '35-2011.00': 9,
    '35-2012.00': 9,
    '35-2013.00': 9,
    '35-2014.00': 9,
    '35-2015.00': 9,
    '35-9011.00': 9,
    '35-9021.00': 9,
    '35-1012.00': 9,
    '35-9099.00': 9,
    '35-2021.00': 9,
    '35-3041.00': 9,
    '11-9051.00': 9,
    '35-9031.00': 9,
    '35-3031.00': 9,
    '43-4181.00': 9,
    '39-7011.00': 9,
    '41-3041.00': 9,
    '39-7012.00': 9,
    '13-2071.00': 10,
    '19-3033.00': 10,
    '21-1019.00': 10,
    '19-3032.00': 10,
    '21-1013.00': 10,
    '21-1023.00': 10,
    '21-1014.00': 10,
    '19-3039.02': 10,
    '19-3039.00': 10,
    '21-1015.00': 10,
    '19-3034.00': 10,
    '21-1011.00': 10,
    '39-9011.00': 10,
    '39-9011.01': 10,
    '21-1021.00': 10,
    '21-2011.00': 10,
    '21-1099.00': 10,
    '21-1094.00': 10,
    '21-2021.00': 10,
    '21-1091.00': 10,
    '21-1022.00': 10,
    '21-2099.00': 10,
    '11-9151.00': 10,
    '21-1093.00': 10,
    '21-1029.00': 10,
    '39-5011.00': 10,
    '39-4011.00': 10,
    '39-1014.00': 10,
    '39-9031.00': 10,
    '39-4021.00': 10,
    '11-9171.00': 10,
    '39-5012.00': 10,
    '51-6011.00': 10,
    '39-3093.00': 10,
    '39-5092.00': 10,
    '31-9011.00': 10,
    '39-4031.00': 10,
    '31-1122.00': 10,
    '39-4012.00': 10,
    '51-6021.00': 10,
    '39-9041.00': 10,
    '39-5093.00': 10,
    '39-5094.00': 10,
    '11-9179.02': 10,
    '51-6052.00': 10,
    '15-2051.01': 11,
    '15-1299.08': 11,
    '15-1232.00': 11,
    '15-1243.01': 11,
    '15-1243.00': 11,
    '15-1299.03': 11,
    '15-1299.02': 11,
    '15-1299.09': 11,
    '13-1161.01': 11,
    '15-1253.00': 11,
    '15-1255.01': 11,
    '15-1299.01': 11,
    '15-1241.00': 11,
    '15-1231.00': 11,
    '15-1242.00': 11,
    '15-1212.00': 11,
    '15-1244.00': 11,
    '15-1241.01': 11,
    '15-1251.00': 11,
    '15-1211.00': 11,
    '15-1211.01': 11,
    '15-1252.00': 11,
    '15-1254.00': 11,
    '33-3012.00': 12,
    '33-1011.00': 12,
    '21-1092.00': 12,
    '29-2042.00': 12,
    '33-2021.00': 12,
    '33-2011.00': 12,
    '33-1021.00': 12,
    '33-2022.00': 12,
    '43-5031.00': 12,
    '33-9011.00': 12,
    '33-3021.00': 12,
    '33-1012.00': 12,
    '33-3031.00': 12,
    '19-4092.00': 12,
    '33-3051.04': 12,
    '33-3021.06': 12,
    '33-3041.00': 12,
    '33-3051.00': 12,
    '33-3021.02': 12,
    '33-9021.00': 12,
    '33-3052.00': 12,
    '23-1021.00': 12,
    '23-1022.00': 12,
    '27-3092.00': 12,
    '23-1023.00': 12,
    '23-1012.00': 12,
    '23-1011.00': 12,
    '43-6012.00': 12,
    '23-2099.00': 12,
    '23-2011.00': 12,
    '23-2093.00': 12,
    '33-3011.00': 12,
    '33-9091.00': 12,
    '33-1091.00': 12,
    '33-9031.00': 12,
    '33-9092.00': 12,
    '33-9094.00': 12,
    '33-9099.02': 12,
    '33-9032.00': 12,
    '49-9061.00': 13,
    '49-9091.00': 13,
    '49-2011.00': 13,
    '49-2092.00': 13,
    '49-2094.00': 13,
    '49-2095.00': 13,
    '49-2097.00': 13,
    '49-9099.00': 13,
    '49-1011.00': 13,
    '49-9099.01': 13,
    '49-9031.00': 13,
    '49-9041.00': 13,
    '49-9094.00': 13,
    '49-9071.00': 13,
    '49-9043.00': 13,
    '51-9082.00': 13,
    '49-9062.00': 13,
    '49-9063.00': 13,
    '49-3053.00': 13,
    '49-9069.00': 13,
    '49-2021.00': 13,
    '49-2098.00': 13,
    '49-9064.00': 13,
    '49-9081.00': 13,
    '17-3021.00': 13,
    '17-3027.01': 13,
    '19-4031.00': 13,
    '17-3019.00': 13,
    '17-3023.00': 13,
    '17-3012.00': 13,
    '17-3024.00': 13,
    '17-3028.00': 13,
    '17-3026.00': 13,
    '17-3013.00': 13,
    '17-3027.00': 13,
    '17-3026.01': 13,
    '17-3029.01': 13,
    '19-4051.00': 13,
    '19-4051.02': 13,
    '17-3029.08': 13,
    '13-1023.00': 13,
    '17-3024.01': 13,
    '51-9191.00': 13,
    '51-2011.00': 13,
    '51-2099.00': 13,
    '51-8099.01': 13,
    '51-8013.03': 13,
    '51-3021.00': 13,
    '51-7011.00': 13,
    '51-9011.00': 13,
    '51-8091.00': 13,
    '51-9192.00': 13,
    '51-9124.00': 13,
    '51-2021.00': 13,
    '51-9162.00': 13,
    '51-9161.00': 13,
    '51-9193.00': 13,
    '51-9021.00': 13,
    '51-9031.00': 13,
    '51-9032.00': 13,
    '51-4031.00': 13,
    '51-9081.00': 13,
    '51-4032.00': 13,
    '51-2022.00': 13,
    '51-2023.00': 13,
    '51-2031.00': 13,
    '51-9194.00': 13,
    '51-4021.00': 13,
    '51-6091.00': 13,
    '51-9041.00': 13,
    '51-6092.00': 13,
    '51-2051.00': 13,
    '51-1011.00': 13,
    '51-3091.00': 13,
    '51-3092.00': 13,
    '51-3093.00': 13,
    '51-3099.00': 13,
    '51-4022.00': 13,
    '51-4071.00': 13,
    '51-9051.00': 13,
    '51-7021.00': 13,
    '51-8092.00': 13,
    '51-9071.06': 13,
    '51-9195.04': 13,
    '51-9022.00': 13,
    '51-4033.00': 13,
    '51-4191.00': 13,
    '51-9198.00': 13,
    '51-8013.04': 13,
    '51-9071.00': 13,
    '51-4034.00': 13,
    '51-4192.00': 13,
    '53-7063.00': 13,
    '51-4041.00': 13,
    '51-3022.00': 13,
    '51-4199.00': 13,
    '51-4051.00': 13,
    '51-8013.00': 13,
    '51-4035.00': 13,
    '51-9023.00': 13,
    '51-4061.00': 13,
    '51-7031.00': 13,
    '51-9195.00': 13,
    '51-4072.00': 13,
    '51-4081.00': 13,
    '51-8011.00': 13,
    '51-9083.00': 13,
    '51-9111.00': 13,
    '51-9123.00': 13,
    '51-9196.00': 13,
    '51-4062.00': 13,
    '51-7032.00': 13,
    '51-8093.00': 13,
    '51-9151.00': 13,
    '51-8099.00': 13,
    '51-4193.00': 13,
    '51-9195.05': 13,
    '51-4052.00': 13,
    '51-8012.00': 13,
    '53-7062.04': 13,
    '51-4023.00': 13,
    '51-7041.00': 13,
    '51-9141.00': 13,
    '51-9012.00': 13,
    '51-6051.00': 13,
    '51-6031.00': 13,
    '51-6041.00': 13,
    '51-6042.00': 13,
    '51-3023.00': 13,
    '51-4121.00': 13,
    '51-9195.03': 13,
    '51-2092.00': 13,
    '51-6061.00': 13,
    '51-6062.00': 13,
    '51-6063.00': 13,
    '51-6064.00': 13,
    '51-6099.00': 13,
    '51-2061.00': 13,
    '51-9197.00': 13,
    '51-4111.00': 13,
    '51-4194.00': 13,
    '51-6093.00': 13,
    '51-4122.00': 13,
    '51-7099.00': 13,
    '51-7042.00': 13,
    '51-9061.00': 13,
    '43-5061.00': 13,
    '43-5111.00': 13,
    '27-3031.00': 14,
    '11-2011.00': 14,
    '11-2021.00': 14,
    '11-9141.00': 14,
    '11-2032.00': 14,
    '11-2022.00': 14,
    '13-1161.00': 14,
    '27-1026.00': 14,
    '41-9012.00': 14,
    '13-1022.00': 14,
    '41-3011.00': 14,
    '41-2011.00': 14,
    '41-2021.00': 14,
    '41-9011.00': 14,
    '41-9091.00': 14,
    '53-3031.00': 14,
    '41-1012.00': 14,
    '41-1011.00': 14,
    '41-2022.00': 14,
    '41-9021.00': 14,
    '41-9022.00': 14,
    '41-2031.00': 14,
    '41-9099.00': 14,
    '41-9031.00': 14,
    '41-3091.00': 14,
    '41-4012.00': 14,
    '41-4011.00': 14,
    '41-4011.07': 14,
    '41-9041.00': 14,
    '19-1029.04': 15,
    '17-2011.00': 15,
    '11-9041.00': 15,
    '17-2141.02': 15,
    '11-9041.01': 15,
    '17-2041.00': 15,
    '17-2061.00': 15,
    '17-2071.00': 15,
    '17-2072.00': 15,
    '17-2199.03': 15,
    '17-2199.00': 15,
    '17-2111.02': 15,
    '17-2141.01': 15,
    '17-2111.00': 15,
    '17-2112.01': 15,
    '17-2112.00': 15,
    '17-2112.03': 15,
    '17-2121.00': 15,
    '17-2131.00': 15,
    '17-2141.00': 15,
    '17-2199.05': 15,
    '17-2199.06': 15,
    '17-2151.00': 15,
    '17-2199.09': 15,
    '17-2161.00': 15,
    '17-2171.00': 15,
    '17-2199.07': 15,
    '17-2072.01': 15,
    '17-2199.08': 15,
    '17-2199.11': 15,
    '17-2112.02': 15,
    '17-2199.10': 15,
    '19-3091.00': 15,
    '19-2011.00': 15,
    '19-2021.00': 15,
    '19-1021.00': 15,
    '19-1029.01': 15,
    '19-1029.00': 15,
    '15-2041.01': 15,
    '17-1021.00': 15,
    '19-2031.00': 15,
    '19-2041.01': 15,
    '15-2051.02': 15,
    '15-1221.00': 15,
    '19-1031.00': 15,
    '19-3011.00': 15,
    '19-3011.01': 15,
    '19-2041.02': 15,
    '19-2041.00': 15,
    '19-1029.03': 15,
    '19-3092.00': 15,
    '19-2042.00': 15,
    '19-3093.00': 15,
    '19-2043.00': 15,
    '19-2041.03': 15,
    '19-1099.00': 15,
    '19-4044.00': 15,
    '19-2032.00': 15,
    '15-2051.00': 15,
    '15-2099.00': 15,
    '15-2021.00': 15,
    '19-1022.00': 15,
    '19-1029.02': 15,
    '19-1031.03': 15,
    '19-2099.00': 15,
    '19-2012.00': 15,
    '19-3094.00': 15,
    '19-4012.01': 15,
    '19-4099.01': 15,
    '19-1031.02': 15,
    '19-2099.01': 15,
    '19-4099.03': 15,
    '19-4061.00': 15,
    '19-3099.00': 15,
    '19-3041.00': 15,
    '15-2041.00': 15,
    '19-3022.00': 15,
    '19-3099.01': 15,
    '49-3011.00': 16,
    '53-6031.00': 16,
    '49-3021.00': 16,
    '49-3022.00': 16,
    '49-3023.00': 16,
    '49-2091.00': 16,
    '49-3091.00': 16,
    '49-3031.00': 16,
    '53-7061.00': 16,
    '49-2093.00': 16,
    '49-2096.00': 16,
    '49-3042.00': 16,
    '49-3051.00': 16,
    '49-3052.00': 16,
    '49-3043.00': 16,
    '47-4061.00': 16,
    '49-3092.00': 16,
    '49-9097.00': 16,
    '49-3093.00': 16,
    '43-5032.00': 16,
    '13-1081.00': 16,
    '13-1081.02': 16,
    '13-1081.01': 16,
    '11-3071.00': 16,
    '43-3021.00': 16,
    '43-5011.00': 16,
    '43-5011.01': 16,
    '53-6021.00': 16,
    '53-1041.00': 16,
    '53-2011.00': 16,
    '53-3011.00': 16,
    '53-6011.00': 16,
    '53-3051.00': 16,
    '53-3052.00': 16,
    '53-5021.00': 16,
    '53-2012.00': 16,
    '43-5021.00': 16,
    '53-1042.00': 16,
    '53-1043.00': 16,
    '53-2031.00': 16,
    '53-7071.00': 16,
    '53-3032.00': 16,
    '53-7051.00': 16,
    '53-7062.00': 16,
    '53-3033.00': 16,
    '53-4011.00': 16,
    '53-4022.00': 16,
    '53-7199.00': 16,
    '53-3099.00': 16,
    '53-5022.00': 16,
    '53-7064.00': 16,
    '53-7072.00': 16,
    '53-4099.00': 16,
    '53-4013.00': 16,
    '53-4031.00': 16,
    '53-1042.01': 16,
    '53-5011.00': 16,
    '53-5031.00': 16,
    '53-4041.00': 16,
    '53-7121.00': 16,
    '53-3053.00': 16,
    '53-6061.00': 16,
    '53-6032.00': 16,
    '53-7073.00': 16,
    '53-2021.00': 16,
    '53-2022.00': 16,
    '53-3054.00': 16,
    '53-6041.00': 16,
};

export default data;



// WEBPACK FOOTER //
// ./src/client/utils/occupationToSubjectArea.js